import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, " Log in ", -1)
const _hoisted_3 = { class: "input" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email address", -1)
const _hoisted_5 = { class: "input" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  id: "login_button",
  class: "mt-4 btn-pers",
  type: "submit"
}, " Login ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "login-form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          class: "form-control",
          type: "text",
          name: "email",
          placeholder: "Enter email address"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          class: "form-control",
          type: "password",
          name: "password",
          placeholder: "Enter password"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", {
        id: "login-alert",
        class: _normalizeClass(["alert alert-warning alert-dismissible fade show mt-5", { 'd-none': _ctx.alertHidden }]),
        role: "alert"
      }, [
        _createTextVNode(_toDisplayString(_ctx.errorMsg) + " ", 1),
        _createElementVNode("input", {
          type: "button",
          class: "btn-close",
          "aria-label": "Close",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.alertHidden = true, ["prevent"]))
        })
      ], 2)
    ], 32)
  ]))
}